<button
  phx-button
  phxButtonRole="secondary"
  phxButtonType="default"
  phxSize="small"
  [phxPrefixIcon]="ellipsesIcon"
  [disabled]="phxDisabled"
  [phxDropdownFor]="actionsDropdown"
  [phxDisabled]="phxDisabled"
  phxTrigger="click"
  phxPosition="bottomRight"
  aria-label="Row actions"
></button>

<phx-dropdown #actionsDropdown>
  <phx-menu *ngIf="phxMenuItems?.length; else projectedMenu">
    <ng-container *ngFor="let item of phxMenuItems">
      <phx-menu-item *ngIf="item.isDivider">
        <phx-divider phxMarginY="none"></phx-divider>
      </phx-menu-item>
      <phx-menu-item
        *ngIf="asMenuItem(item) as menuItem"
        [disabled]="!!menuItem.disabled"
        [class.phx-table-cell-action-item-negative]="menuItem.intent === 'negative'"
        (phxClick)="onItemClick(menuItem)"
        >{{ menuItem.label }}</phx-menu-item
      >
    </ng-container>
  </phx-menu>

  <!-- Consumer must project a full <phx-menu> (not bare items). -->
  <ng-template #projectedMenu>
    <ng-content select="phx-menu"></ng-content>
  </ng-template>
</phx-dropdown>
